import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EncryptionService } from '../../services/encryption.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SetInterceptorService implements HttpInterceptor {
  private _encryptionService = inject(EncryptionService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const storageKey = localStorage.getItem(environment.storageKey);
    const token: string | null = storageKey ?? null;

    const baseHeaders = {
      authorization: token ? `Bearer ${token}` : '',
      date: new Date().toISOString(),
      'x-portal': 'admin',
    };

    const isFormData = req.body instanceof FormData;
    const isUploadApi = req.url.includes('/media/upload');

    if (isUploadApi && isFormData) {
      return next.handle(req);
    }

    // Otherwise build our custom headers
    const newHeaders: Record<string, string> = {
      hash: this._encryptionService.encryptData(baseHeaders),
      deviceType: 'web',
      'x-portal': 'admin',
      language: localStorage.getItem('language') || 'en',
    };

    if (!isFormData) {
      newHeaders['Content-Type'] = 'application/json';
    }

  
    
    let clonedReq = req.clone({
      setHeaders: newHeaders,
    });    
    console.warn(clonedReq, 'dkdkdkdk')
    // Encrypt JSON body if applicable
    if (
      !isFormData &&
      (req.method.toLowerCase() === 'post' || req.method.toLowerCase() === 'put')
    ) {    
      clonedReq = clonedReq.clone({
        body: {
          hash: this._encryptionService.encryptData(clonedReq.body),
        },
      });
    }

    return next.handle(clonedReq);
  }
}
